import { ARP_NAVIGATION_EVENTS } from '../../event_bus_modules/auction_registration_navigation';

$(() => {
  const bidx1Details = $(
    '#auction-registration-deposit-bank-transfer-bidx1-details'
  );
  const completeButton = $('#complete-navigation');

  completeButton.on('click', () => {
    EVENT_BUS.dispatch(ARP_NAVIGATION_EVENTS.NAVIGATION_BUTTON_CLICK);
  });
});
